import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { push } from "react-router-redux";
import GoogleMapReact from "google-map-react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import * as dateFormat from "dateformat";
import Box from "../components/Box";
import PropertyLabel from "../components/PropertyLabel";

/* global admin view styling */
import "../styles/MachinesAdminView.css";
import ErrorMessage from "../components/ErrorMessage";
import LoadingProgress from "../components/LoadingProgress";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import { Line, Bar } from "react-chartjs-2";

import MachineStatusBadge from "../components/MachineStatusBadge";
import { history } from "../store";
import MachineMarker from "../components/MachineMarker";
import RemoteActionsList from "../components/RemoteActionsList";
import MoneyTable from "../components/MoneyTable";
import { fetchAudits, fetchAuditsCSV } from "../actions/audits";

import RemoteActionAddForm from "../forms/RemoteActionAddForm";
import CriticalActionAddForm from "../forms/CriticalActionAddForm";
import { deleteMachine, fetchMachine } from "../actions/machines";
import { getMachinePicture, getMachineCoordinates } from "../utils/machines";
import { fetchRemoteActions } from "../actions/remoteactions";
import { GMAPS_KEY } from "../config";
import SecurityBoxTable from "../components/SecurityBoxTable";

import { fetchMatrixs } from "../actions/matrixs";
import { fetchArticles } from "../actions/articles";
import { fetchRentals } from "../actions/rentals";
import { fetchKeepAliveSignals } from "../actions/keepalivesignals";

import MatrixConstructor from "../components/MatrixConstructor";
import MatrixConstructorAdmin from "../components/MatrixConstructorAdmin";
import MatrixConstructorSignal from "../components/MatrixConstructorSignal";
import MatrixConstructorBattery from "../components/MatrixConstructorBattery";
import MatrixConstructorVersion from "../components/MatrixConstructorVersion";
import MatrixConstructorBootloader from "../components/MatrixConstructorBootloader";
import MatrixConstructorOpens from "../components/MatrixConstructorOpens";

import AssignedModuleList from "../components/AssignedModuleList";
import AssignedPairingSecurityList from "../components/AssignedPairingSecurityList";
import AssignedPaymentDevicesList from "../components/AssignedPaymentDevicesList";

class MachineDetailsView extends React.Component {
  // Room number mapping for machine ID 68b823e2ef2a539b350dab2a
  static ROOM_NUMBERS = [
    // Floor 1
    101, 102, 103, 104, 105, 106, 109, 111, 112, 113, 114, 115, 116, 117, 118,
    119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133,
    134, 135, 136, 137, 138, 140, 142, 144,
    // Floor 2
    201, 202, 203, 204, 205, 206, 209, 211, 212, 213, 214, 215, 216, 217, 218,
    219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233,
    234, 235, 236, 237, 238, 240, 242, 244,
    // Floor 3
    301, 302, 303, 304, 305, 306, 309, 311, 312, 313, 314, 315, 316, 317, 318,
    319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333,
    334, 335, 336, 337, 338, 340, 342, 344,
    // Floor 4
    400, 401, 402, 403, 404, 407, 409, 410, 411, 412, 413, 414, 415, 416, 418,
    420, 422, 423, 424, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435,
  ];

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);

    this.state = {
      loaded: false,
      deleting: false,
      deleteConfirmShown: false,
      userpinShown: false,
      batteriesShown: false,
      showModules: false,
      showPaymentDevices: false,
      showSecurity: false,
      showMatrixAdmin: false,
      showMatrixBattery: false,
      activeTab: "2",
      adminActiveTab: "config",
      matrixAutoUpdate: false,
      startDate: "",
      endDate: "",
      rentals: [],
      blockedLockers: [],
      uptimeDay: null,
      uptimeZoomHours: 0,
    };

    this.delete = this.delete.bind(this);
    this.deleteConfirmShow = this.deleteConfirmShow.bind(this);
    this.deleteConfirmToggle = this.deleteConfirmToggle.bind(this);
    this.userpinToggle = this.userpinToggle.bind(this);
    this.batteriesToggle = this.batteriesToggle.bind(this);
    this.downloadAgenczia = this.downloadAgenczia.bind(this);

    this.createMatrix = this.createMatrix.bind(this);
    this.refreshMatrix = this.refreshMatrix.bind(this);
    this.handleFetchRentals = this.handleFetchRentals.bind(this);
    this.toggleAdmin = this.toggleAdmin.bind(this);
  }

  toggleAdmin(tab) {
    if (this.state.adminActiveTab !== tab) {
      this.setState({ adminActiveTab: tab });
    }
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  getRoomNumber(index) {
    const {
      machines: { machine },
    } = this.props;

    // Check if this is the specific machine that needs room number conversion
    if (machine && machine._id === "68b823e2ef2a539b350dab2a") {
      // Return room number from the mapping array
      return MachineDetailsView.ROOM_NUMBERS[index] || index;
    }

    // Default behavior for other machines
    return index + (machine ? machine.FirstIndex : 0);
  }

  componentDidMount() {
    const {
      fetchMachine,
      fetchRemoteActions,
      fetchMatrixs,
      fetchArticles,
      match,
    } = this.props;

    fetchArticles();

    fetchMachine(match.params.id)
      .then(() => {
        const {
          machines: { machine },
        } = this.props;

        if (machine) {
          fetchMatrixs(machine._id, "", "", "");
          fetchRemoteActions(machine.Serial);
          this.props.fetchKeepAliveSignals(machine._id);
        }
      })
      .catch((error) => {
        // Handle error if the fetchMachine request fails
        console.error("Error fetching machine:", error);
      });
  }

  setSeasonDatesAndSubmit = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    let startDate, endDate;

    console.log("Current date: ", currentMonth + "/" + currentYear);

    if (currentMonth >= 0 && currentMonth < 7) {
      // If current date is between January 1st and May 1st
      startDate = new Date(); // October 1st last year
      endDate = new Date(currentYear, 5, 1); // May 1st current year
    } else if (currentMonth >= 7 && currentMonth <= 11) {
      // If current date is between October 1st and December 31st
      startDate = new Date(); // October 1st current year
      endDate = new Date(currentYear + 1, 5, 1); // May 1st next year
    }

    // Both startDate and endDate should be defined by this point
    if (startDate && endDate) {
      this.setState(
        {
          startDate: startDate.toISOString().split("T")[0],
          endDate: endDate.toISOString().split("T")[0],
        },
        this.handleFetchRentals,
      );
    } else {
      console.error("Failed to calculate the season dates.");
    }
  };

  handleFetchRentals(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const { startDate, endDate } = this.state;
    const {
      fetchMatrixs,
      machines: { machine },
    } = this.props;

    if (!startDate || !endDate || !machine) return;

    let newEndDate = new Date(endDate);
    newEndDate.setHours(23, 59, 59, 999);

    this.props
      .fetchRentals(machine._id, "", startDate, newEndDate, "")
      .then((response) => {
        let rentals = response.response; // Accessing the actual rentals array

        if (rentals && rentals.length > 0) {
          // Filter out rentals with Status "ERROR" or "CANCELED" and Type "COUNTERINVOICE"
          rentals = rentals.filter(
            (rental) =>
              rental.Status !== "ERROR" &&
              rental.Status !== "CANCELED" &&
              rental.Type !== "COUNTERINVOICE",
          );

          const blockedLockers = rentals.flatMap(
            (rental) => rental.LockerMatricula,
          );

          this.setState({ rentals, blockedLockers }, () => {
            // After state is updated, fetch the matrix and rerender
            fetchMatrixs(machine._id, "", "", "");
          });
        } else {
          // If rentals is empty, ensure blockedLockers is also empty
          this.setState({ rentals: [], blockedLockers: [] }, () => {
            // After state is updated, fetch the matrix and rerender
            fetchMatrixs(machine._id, "", "", "");
          });
        }
      })
      .catch((error) => console.error("Error fetching rentals:", error));
  }

  refreshMatrix() {
    const {
      fetchMatrixs,
      machines: { machine },
    } = this.props;
    if (machine) {
      fetchMatrixs(machine._id, "", "", "");
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  componentWillReceiveProps(nextProps) {
    const { machines, customers, remoteActions } = this.props;

    // If the route id changed (e.g. user picked another machine from the
    // Nightscan drawer while already on a details page), refetch it.
    if (
      nextProps.match &&
      this.props.match &&
      nextProps.match.params.id !== this.props.match.params.id
    ) {
      this.setState({ loaded: false });
      this.props.fetchMachine(nextProps.match.params.id)
        .then(() => {
          const { machines: { machine } } = this.props;
          if (machine) {
            this.props.fetchMatrixs(machine._id, "", "", "");
            this.props.fetchRemoteActions(machine.Serial);
          }
        })
        .catch((error) => {
          console.error("Error fetching machine:", error);
        });
    }

    if (this.state.deleting && !nextProps.machines.machine) {
      this.props.push("/machines");
    }

    if (this.props.remoteActions.remoteActionsNeedRefresh) {
      this.setState({ loaded: false });
      this.props.fetchRemoteActions(machines.Serial);
    }

    if (!this.state.loaded && machines && customers && remoteActions) {
      this.setState({ loaded: true });
    }
  }

  delete() {
    const {
      deleteMachine,
      machines: { machine },
    } = this.props;

    this.setState({ deleting: true });
    deleteMachine(machine.Serial);
  }

  deleteConfirmShow() {
    this.setState({ deleteConfirmShown: true });
  }

  deleteConfirmToggle() {
    this.setState({ deleteConfirmShown: !this.state.deleteConfirmShown });
  }

  userpinToggle() {
    this.setState({ userpinShown: !this.state.userpinShown });
  }

  batteriesToggle() {
    this.setState({ batteriesShown: !this.state.batteriesShown });
  }

  downloadAgenczia() {
    const {
      machines: { machine },
    } = this.props;

    const dataStr =
      "data:text/json;charset=utf-8," +
      encodeURIComponent(JSON.stringify(machine.Agenczia_della_entrate.data));
    const downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute(
      "download",
      "agenczia_della_entrate" + ".json",
    );
    document.body.appendChild(downloadAnchorNode);
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  renderLanguages(languages) {
    let languageImages = [];

    languages.forEach((language) => {
      const languageCode = language.Language.split("_")[0];

      languageImages.push(
        <div className="col">
          <img
            className="machinelistlanguage"
            src={`/languages/${languageCode.toLowerCase()}.png`}
            alt={language.Language}
          ></img>
        </div>,
      );
    });

    return <div className="row">{languageImages}</div>;
  }

  renderLanguage(language) {
    const languageCode = language.split("_")[0];

    return (
      <img
        className="machinelistlanguage"
        src={`/languages/${languageCode.toLowerCase()}.png`}
        alt={language}
      ></img>
    );
  }

  generateLiveLine() {
    const {
      machines: { machine },
      audits,
    } = this.props;

    if (!machine) {
      return <LoadingProgress />;
    }

    if (!audits) {
      return <LoadingProgress />;
    }

    const timestamps = [];

    // Filter audits with audit.Evento === "REBOOT"
    audits.forEach((audit) => {
      if (audit.Evento === "REBOOT") {
        timestamps.push(audit.TimeStamp);
      }
    });

    // Function to extract the hour and minute from a timestamp
    const getHourMinute = (timestamp) => {
      const date = new Date(timestamp);
      const hour = date.getHours();
      const minute = date.getMinutes();
      return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
    };

    // Count the number of occurrences for each hour and minute combination
    const hourMinuteCounts = {};
    timestamps.forEach((timestamp) => {
      const hourMinute = getHourMinute(timestamp);
      hourMinuteCounts[hourMinute] = (hourMinuteCounts[hourMinute] || 0) + 1;
    });

    // Generate the chart data
    const chartData = {
      labels: Object.values(hourMinuteCounts),
      datasets: [
        {
          label: "Reboots",
          data: Object.values(hourMinuteCounts),
          backgroundColor: "rgba(75, 192, 192, 0.6)", // Bar color
        },
      ],
    };

    // Chart options
    const chartOptions = {
      scales: {
        y: {
          beginAtZero: true,
        },
      },
      legend: {
        display: false,
      },
    };

    return (
      <div>
        <Bar data={chartData} options={chartOptions} />
      </div>
    );
  }

  generateUptimeChart() {
    const { keepAliveSignals, machines: { machine } } = this.props;
    const { uptimeDay, uptimeZoomHours } = this.state;

    if (!machine) return null;
    if (!keepAliveSignals || keepAliveSignals.loading) return <LoadingProgress />;

    const STATUS_CONFIG = {
      'OPERATIVE':         { color: '#00d34d', label: 'Operativo' },
      'OPERATIVE_SLEEP':   { color: '#86efac', label: 'Operativo (Sleep)' },
      'SLEEP':             { color: '#2c5794', label: 'Sleep' },
      'MAINTENANCE':       { color: '#fb923c', label: 'Mantenimiento' },
      'MAINTENANCE_SLEEP': { color: '#fdba74', label: 'Mant. Sleep' },
      'NIGHT_SCAN':        { color: '#009be2', label: 'Night Scan' },
      'LOCKERS_FULL':      { color: '#ef4444', label: 'Taquillas llenas' },
      'TICKET_EMPTY':      { color: '#f87171', label: 'Sin tickets' },
      'OFFLINE':           { color: '#e5e7eb', label: 'Offline' },
    };
    const DEFAULT_CFG = { color: '#cbd5e1', label: 'Desconocido' };

    const OFFLINE_THRESHOLD_MS = 35 * 60 * 1000;
    const now = new Date();
    const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
    const fullStart = new Date(now.getTime() - SEVEN_DAYS_MS);

    const allSignals = [...(keepAliveSignals.signals || [])].sort(
      (a, b) => new Date(a.Date) - new Date(b.Date)
    );

    // Build all segments over the full 7-day window
    const allSegments = [];

    if (allSignals.length === 0) {
      allSegments.push({ start: fullStart, end: now, status: 'OFFLINE' });
    } else {
      const firstSigTime = new Date(allSignals[0].Date);
      if (firstSigTime > fullStart) {
        allSegments.push({ start: fullStart, end: firstSigTime, status: 'OFFLINE' });
      }
      allSignals.forEach((sig, i) => {
        const sigStart = new Date(sig.Date);
        const nextSig  = allSignals[i + 1];
        if (nextSig) {
          const nextStart = new Date(nextSig.Date);
          const gap = nextStart - sigStart;
          if (gap > OFFLINE_THRESHOLD_MS) {
            const offlineStart = new Date(sigStart.getTime() + OFFLINE_THRESHOLD_MS);
            allSegments.push({ start: sigStart,     end: offlineStart, status: sig.Status });
            allSegments.push({ start: offlineStart, end: nextStart,    status: 'OFFLINE'  });
          } else {
            allSegments.push({ start: sigStart, end: nextStart, status: sig.Status });
          }
        } else {
          if (now - sigStart <= OFFLINE_THRESHOLD_MS) {
            allSegments.push({ start: sigStart, end: now, status: sig.Status });
          } else {
            const offlineStart = new Date(sigStart.getTime() + OFFLINE_THRESHOLD_MS);
            allSegments.push({ start: sigStart,     end: offlineStart, status: sig.Status });
            allSegments.push({ start: offlineStart, end: now,          status: 'OFFLINE'  });
          }
        }
      });
    }

    // Determine view window: null = full 7 days, N = the Nth most-recent 24h block
    // Day 1 = last 24h (most recent), Day 7 = 6-7 days ago (oldest)
    let viewStart, viewEnd;
    if (uptimeDay !== null) {
      viewEnd   = new Date(now.getTime() - (uptimeDay - 1) * 24 * 60 * 60 * 1000);
      viewStart = new Date(viewEnd.getTime() - 24 * 60 * 60 * 1000);
    } else {
      viewStart = fullStart;
      viewEnd   = now;
    }

    // Apply zoom: each zoom step removes 1h from the past (shifts viewStart forward)
    // Hard cap: viewStart can never exceed now - 1h
    const HOUR_MS = 60 * 60 * 1000;
    const maxByWindow  = Math.floor((viewEnd.getTime() - viewStart.getTime()) / HOUR_MS) - 1;
    const maxByNow     = Math.floor((now.getTime() - HOUR_MS - viewStart.getTime()) / HOUR_MS);
    const maxZoomHours = Math.min(maxByWindow, maxByNow);
    const clampedZoom = Math.min(uptimeZoomHours, maxZoomHours);
    if (clampedZoom > 0) {
      viewStart = new Date(viewStart.getTime() + clampedZoom * HOUR_MS);
    }

    // Clip segments to view window
    const segments = allSegments
      .filter(seg => seg.end > viewStart && seg.start < viewEnd)
      .map(seg => ({
        ...seg,
        start: seg.start < viewStart ? viewStart : seg.start,
        end:   seg.end   > viewEnd   ? viewEnd   : seg.end,
      }));

    const totalMs = viewEnd.getTime() - viewStart.getTime();

    const fmtLabel = (d) => {
      const dt = new Date(d);
      return (
        `${String(dt.getDate()).padStart(2, '0')}/${String(dt.getMonth() + 1).padStart(2, '0')} ` +
        `${String(dt.getHours()).padStart(2, '0')}:${String(dt.getMinutes()).padStart(2, '0')}`
      );
    };

    // Day tick marks between viewStart and viewEnd
    const dayTicks = [];
    const startDay = new Date(viewStart);
    startDay.setHours(0, 0, 0, 0);
    startDay.setDate(startDay.getDate() + 1);
    for (let d = new Date(startDay); d < viewEnd; d.setDate(d.getDate() + 1)) {
      const pct = (d.getTime() - viewStart.getTime()) / totalMs * 100;
      dayTicks.push({
        pct,
        label: `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`
      });
    }

    const presentStatuses = [...new Set(segments.map(s => s.status))].filter(s => s !== 'OFFLINE');

    // Day filter buttons — 7 = oldest day, 1 = most recent day
    const btnBase = {
      padding: '2px 8px',
      fontSize: 11,
      borderRadius: 4,
      border: '1px solid #d1d5db',
      cursor: 'pointer',
      lineHeight: '18px',
    };
    const btnActive   = { ...btnBase, backgroundColor: '#3b82f6', color: '#fff', borderColor: '#3b82f6' };
    const btnInactive = { ...btnBase, backgroundColor: '#fff', color: '#374151' };

    const btnZoom = { ...btnBase, backgroundColor: '#fff', color: '#374151', fontWeight: 600, minWidth: 28, textAlign: 'center' };

    const dayButtons = (
      <div style={{ display: 'flex', gap: 4, marginBottom: 8, flexWrap: 'wrap', alignItems: 'center' }}>
        <button
          style={uptimeDay === null ? btnActive : btnInactive}
          onClick={() => this.setState({ uptimeDay: null, uptimeZoomHours: 0 })}
        >7 días</button>
        {[7, 6, 5, 4, 3, 2, 1].map(d => (
          <button
            key={d}
            style={uptimeDay === d ? btnActive : btnInactive}
            onClick={() => this.setState({ uptimeDay: d, uptimeZoomHours: 0 })}
          >Día {d}</button>
        ))}
        <span style={{ marginLeft: 8, marginRight: 8, width: 1, height: 16, backgroundColor: '#d1d5db', display: 'inline-block' }} />
        <button
          style={clampedZoom >= maxZoomHours ? { ...btnZoom, opacity: 0.4, cursor: 'not-allowed' } : btnZoom}
          disabled={clampedZoom >= maxZoomHours}
          title="Reducir 1 hora del inicio"
          onClick={() => this.setState(s => ({ uptimeZoomHours: s.uptimeZoomHours + 1 }))}
        >−1h</button>
        {uptimeZoomHours > 0 && (
          <button
            style={{ ...btnZoom, color: '#3b82f6' }}
            title="Ampliar 1 hora al inicio"
            onClick={() => this.setState(s => ({ uptimeZoomHours: Math.max(0, s.uptimeZoomHours - 1) }))}
          >+1h</button>
        )}
        {uptimeZoomHours > 0 && (
          <button
            style={{ ...btnZoom, color: '#6b7280', fontSize: 10 }}
            title="Restablecer zoom"
            onClick={() => this.setState({ uptimeZoomHours: 0 })}
          >↺</button>
        )}
      </div>
    );

    if (segments.length === 0) {
      return (
        <div style={{ padding: '4px 0' }}>
          {dayButtons}
          <div style={{ color: '#9ca3af', fontSize: 12 }}>Sin datos para este período</div>
        </div>
      );
    }

    return (
      <div style={{ padding: '4px 0' }}>
        {dayButtons}
        <div style={{ position: 'relative' }}>
          {/* Bar — OFFLINE segments render at 4px height (floor), active statuses at full height */}
          <div style={{ position: 'relative', display: 'flex', alignItems: 'flex-end', width: '100%', height: 40, borderRadius: 4, overflow: 'hidden', border: '1px solid #d1d5db', backgroundColor: '#f9fafb' }}>
            {segments.map((seg, i) => {
              const widthPct = (seg.end.getTime() - seg.start.getTime()) / totalMs * 100;
              const isOffline = seg.status === 'OFFLINE';
              const cfg = STATUS_CONFIG[seg.status] || DEFAULT_CFG;
              const isLast = i === segments.length - 1;
              return (
                <div
                  key={i}
                  title={`${cfg.label}  ${fmtLabel(seg.start)} → ${fmtLabel(seg.end)}`}
                  style={{ width: `${widthPct}%`, height: isOffline ? 4 : '100%', backgroundColor: cfg.color, minWidth: 1, flexShrink: 0, borderRight: isLast ? 'none' : '1px solid rgba(255,255,255,0.2)', boxSizing: 'border-box' }}
                />
              );
            })}
            {/* Day-change vertical lines overlaid on the bar */}
            {dayTicks.map((t, i) => (
              <div
                key={`vline-${i}`}
                style={{
                  position: 'absolute',
                  left: `${t.pct}%`,
                  top: 0,
                  bottom: 0,
                  width: 1,
                  backgroundColor: 'rgba(0,0,0,0.25)',
                  pointerEvents: 'none',
                }}
              />
            ))}
          </div>
          {/* X-axis ticks */}
          <div style={{ position: 'relative', height: 18, marginTop: 2, fontSize: 10, color: '#9ca3af' }}>
            <span style={{ position: 'absolute', left: 0 }}>{fmtLabel(viewStart)}</span>
            {dayTicks.map((t, i) => (
              <span key={i} style={{ position: 'absolute', left: `${t.pct}%`, transform: 'translateX(-50%)' }}>
                {t.label}
              </span>
            ))}
            <span style={{ position: 'absolute', right: 0 }}>{uptimeDay === null ? 'Ahora' : fmtLabel(viewEnd)}</span>
          </div>
        </div>
        {/* Legend — OFFLINE excluded */}
        {presentStatuses.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 14px', marginTop: 6, fontSize: 11, color: '#374151' }}>
            {presentStatuses.map(status => {
              const cfg = STATUS_CONFIG[status] || DEFAULT_CFG;
              return (
                <span key={status} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <span style={{ width: 10, height: 10, backgroundColor: cfg.color, borderRadius: 2, display: 'inline-block', border: '1px solid rgba(0,0,0,0.15)' }} />
                  {cfg.label}
                </span>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  updateMatrixs() {
    const {
      fetchMatrixs,
      machines: { machine },
    } = this.props;

    // set a timer to execute the updateMatrixs function every 5 seconds
    this.timer = setInterval(() => {
      if (this.state.matrixAutoUpdate) {
        fetchMatrixs(machine._id, "", "", "");
        this.createMatrix();
        this.createMatrixAdmin();
        this.createMatrixBattery();
        this.createMatrixSignal();
        this.createMatrixVersion();
        this.createMatrixBootloader();
        this.createMatrixOpens();
      } else {
        clearInterval(this.timer);
      }
    }, 5000); // 5000 milliseconds = 5 seconds
  }

  identifyFaults() {
    const {
      matrixs,
      machines: { machine },
    } = this.props;

    if (!machine || !matrixs) {
      return <LoadingProgress />;
    }

    // BROKEN_LOCK, GREEN_BLOCK, RED_BLOCK, PINPAD_BLOCK, DOOR_BLOCK

    let TOTAL_FAULTS = 0;

    let BROKEN_LOCK = 0;
    let GREEN_BLOCK = 0;
    let RED_BLOCK = 0;
    let PINPAD_BLOCK = 0;
    let DOOR_BLOCK = 0;
    let PINPAD_ACTIVE = 0;

    let brokenLockSN = [];
    let greenBlockSN = [];
    let redBlockSN = [];
    let pinpadBlockSN = [];
    let doorBlockSN = [];
    let pinpadActiveSN = [];

    matrixs.forEach((matrix) => {
      {
        matrix.Serial === machine.Serial &&
          matrix.Locker.forEach((lock, index) => {
            if (lock.FaultCode !== undefined && lock.Status === "FL") {
              switch (lock.FaultCode) {
                case "BROKEN_LOCK":
                  BROKEN_LOCK++;
                  TOTAL_FAULTS++;

                  brokenLockSN.push(
                    <p>{`( ${this.getRoomNumber(index)} ) `}</p>,
                  );
                  break;
                case "GREEN_BLOCK":
                  GREEN_BLOCK++;
                  TOTAL_FAULTS++;

                  greenBlockSN.push(
                    <p>{`( ${this.getRoomNumber(index)} ) `}</p>,
                  );
                  break;
                case "RED_BLOCK":
                  RED_BLOCK++;
                  TOTAL_FAULTS++;

                  redBlockSN.push(<p>{`( ${this.getRoomNumber(index)} ) `}</p>);
                  break;
                case "PINPAD_BLOCK":
                  PINPAD_BLOCK++;
                  TOTAL_FAULTS++;

                  pinpadBlockSN.push(
                    <p>{`( ${this.getRoomNumber(index)} ) `}</p>,
                  );
                  break;
                case "DOOR_BLOCK":
                  DOOR_BLOCK++;
                  TOTAL_FAULTS++;

                  doorBlockSN.push(
                    <p>{`( ${this.getRoomNumber(index)} ) `}</p>,
                  );
                  break;
                case "PINPAD_ACTIVE":
                  PINPAD_ACTIVE++;
                  TOTAL_FAULTS++;

                  pinpadActiveSN.push(
                    <p>{`( ${this.getRoomNumber(index)} ) `}</p>,
                  );
                  break;
                default:
                  break;
              }
            }
          });
      }
    });

    return (
      <div className="kpi-page machine-details">
        <div className="kpi-row mb-4 justify-content-center">
          <div className="kpi-card total-faults">
            <div className="kpi-card-inner">
              <div className="d-flex align-items-center gap-2">
                <div className="kpi-card-icon">
                  <i className="fas fa-bug" />
                </div>
                <div className="kpi-card-title">TOTAL AVERÍAS</div>
              </div>
              <div className="kpi-value">
                <div className="kpi-count">{TOTAL_FAULTS}</div>
              </div>
            </div>
          </div>

          <div className="kpi-card fault">
            <div className="kpi-card-inner">
              <div className="d-flex align-items-center gap-2">
                <div className="kpi-card-icon">
                  <i className="fas fa-wrench" />
                </div>
                <div className="kpi-card-title">Pinchos rotos</div>
              </div>
              <div className="kpi-value">
                <div className="kpi-count">{BROKEN_LOCK}</div>
                <div className="row justify-content-center small-list">
                  {brokenLockSN}
                </div>
              </div>
            </div>
          </div>

          <div className="kpi-card fault">
            <div className="kpi-card-inner">
              <div className="d-flex align-items-center gap-2">
                <div className="kpi-card-icon">
                  <i className="fas fa-lock" />
                </div>
                <div className="kpi-card-title">Pin verde, no abre</div>
              </div>
              <div className="kpi-value">
                <div className="kpi-count">{GREEN_BLOCK}</div>
                <div className="row justify-content-center small-list">
                  {greenBlockSN}
                </div>
              </div>
            </div>
          </div>

          <div className="kpi-card fault">
            <div className="kpi-card-inner">
              <div className="d-flex align-items-center gap-2">
                <div className="kpi-card-icon">
                  <i className="fas fa-times-circle" />
                </div>
                <div className="kpi-card-title">Pin rojo, no abre</div>
              </div>
              <div className="kpi-value">
                <div className="kpi-count">{RED_BLOCK}</div>
                <div className="row justify-content-center small-list">
                  {redBlockSN}
                </div>
              </div>
            </div>
          </div>

          <div className="kpi-card fault">
            <div className="kpi-card-inner">
              <div className="d-flex align-items-center gap-2">
                <div className="kpi-card-icon">
                  <i className="fas fa-keyboard" />
                </div>
                <div className="kpi-card-title">Teclado no enciende</div>
              </div>
              <div className="kpi-value">
                <div className="kpi-count">{PINPAD_BLOCK}</div>
                <div className="row justify-content-center small-list">
                  {pinpadBlockSN}
                </div>
              </div>
            </div>
          </div>

          <div className="kpi-card fault">
            <div className="kpi-card-inner">
              <div className="d-flex align-items-center gap-2">
                <div className="kpi-card-icon">
                  <i className="fas fa-door-open" />
                </div>
                <div className="kpi-card-title">Puerta no cierra</div>
              </div>
              <div className="kpi-value">
                <div className="kpi-count">{DOOR_BLOCK}</div>
                <div className="row justify-content-center small-list">
                  {doorBlockSN}
                </div>
              </div>
            </div>
          </div>

          <div className="kpi-card fault">
            <div className="kpi-card-inner">
              <div className="d-flex align-items-center gap-2">
                <div className="kpi-card-icon">
                  <i className="fas fa-toggle-on" />
                </div>
                <div className="kpi-card-title">Teclado encendido</div>
              </div>
              <div className="kpi-value">
                <div className="kpi-count">{PINPAD_ACTIVE}</div>
                <div className="row justify-content-center small-list">
                  {pinpadActiveSN}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  createMatrix(blockedLockers) {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
      articles,
    } = this.props;

    if (!matrixs) {
      return <LoadingProgress />;
    }

    return (
      <MatrixConstructor
        matrixs={matrixs}
        machine={machine}
        articles={articles}
        refreshMatrix={this.refreshMatrix}
        blockedLockers={blockedLockers}
        getRoomNumber={this.getRoomNumber.bind(this)}
      />
    );
  }

  createMatrixAdmin() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!matrixs) {
      return <LoadingProgress />;
    }

    return (
      <MatrixConstructorAdmin
        matrixs={matrixs}
        machine={machine}
        refreshMatrix={this.refreshMatrix}
        getRoomNumber={this.getRoomNumber.bind(this)}
      />
    );
  }

  createMatrixBattery() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!matrixs) {
      return <LoadingProgress />;
    }

    return (
      <MatrixConstructorBattery
        matrixs={matrixs}
        machine={machine}
        getRoomNumber={this.getRoomNumber.bind(this)}
      />
    );
  }

  createMatrixSignal() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!matrixs) {
      return <LoadingProgress />;
    }

    return (
      <MatrixConstructorSignal
        matrixs={matrixs}
        machine={machine}
        getRoomNumber={this.getRoomNumber.bind(this)}
      />
    );
  }

  createMatrixVersion() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!matrixs) {
      return <LoadingProgress />;
    }

    return (
      <MatrixConstructorVersion
        matrixs={matrixs}
        machine={machine}
        getRoomNumber={this.getRoomNumber.bind(this)}
      />
    );
  }

  createMatrixBootloader() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!matrixs) {
      return <LoadingProgress />;
    }

    return (
      <MatrixConstructorBootloader
        matrixs={matrixs}
        machine={machine}
        getRoomNumber={this.getRoomNumber.bind(this)}
      />
    );
  }

  createMatrixOpens() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!matrixs) {
      return <LoadingProgress />;
    }

    return (
      <MatrixConstructorOpens
        matrixs={matrixs}
        machine={machine}
        getRoomNumber={this.getRoomNumber.bind(this)}
      />
    );
  }

  renderUserpin() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!machine || !matrixs) {
      return <LoadingProgress />;
    }

    let userpinList = [];

    {
      matrixs.forEach((matrix) => {
        {
          matrix.Serial === machine.Serial &&
            matrix.Locker.forEach((lock, index) => {
              if (index < machine.LastIndex) {
                userpinList.push(
                  <div className="ct">
                    <h5>
                      {this.getRoomNumber(index)} - {lock.Pass}
                    </h5>
                  </div>,
                );
              }
            });
        }
      });
    }

    return <div>{userpinList}</div>;
  }

  renderBatteries() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!machine || !matrixs) {
      return <LoadingProgress />;
    }

    let batteriesList = [];

    {
      matrixs.forEach((matrix) => {
        {
          matrix.Serial === machine.Serial &&
            matrix.Locker.forEach((lock, index) => {
              if (index < machine.LastIndex) {
                batteriesList.push(
                  <div className="ct">
                    <h5>
                      {this.getRoomNumber(index)} - {lock.Bateria}
                    </h5>
                  </div>,
                );
              }
            });
        }
      });
    }

    return <div>{batteriesList}</div>;
  }

  getPayments(tipo) {
    switch (tipo) {
      case 0: {
        return "TODOS";
      }
      case 1: {
        return "CASH";
      }
      case 2: {
        return "TPV";
      }
      case 3: {
        return "SCANNER";
      }
      case 4: {
        return "GRATIS";
      }
    }
  }

  getQRMode(tipo) {
    switch (tipo) {
      case 0: {
        return "MTO DIARIO";
      }
      case 1: {
        return "OTO DIARIO SIN PIN";
      }
      case 2: {
        return "OTO DIARIO CON PIN";
      }
    }
  }

  getZoneName(zone) {
    switch (zone) {
      case 0:
        return "GENERAL";
      case 1:
        return "BAQUEIRA";
      case 2:
        return "BERET";
      case 3:
        return "BONAIGUA";
      case 4:
        return "RUDA";
      case 5:
        return "BOSQUE";
      default:
        return "NONE";
    }
  }

  getBillerAcceptance(biller) {
    switch (biller) {
      case "1111":
        return "TODOS 5€ / 10€ / 20€ / 50€";
      case "0111":
        return "5€ / 10€ / 20€";
      case "0011":
        return "5€ / 10€";
      case "0001":
        return "5€";
      case "0000":
        return "NINGÚNO";
      default:
        return "NONE";
    }
  }

  getCoinAcceptance(coin) {
    switch (coin) {
      case 0:
        return "0,50€";
      case 1:
        return "1€";
      case 2:
        return "2€";
      case 3:
        return "1€ / 2€";
      default:
        return "NONE";
    }
  }

  render() {
    const {
      matrixs,
      role,
      type,
      machines,
      machines: { machine },
      remoteActions,
      category,
    } = this.props;
    const { startDate, endDate, blockedLockers } = this.state;

    if (machines.error) {
      return <ErrorMessage message={machines.error.message} />;
    }

    if (!machine || machines.loading || !remoteActions) {
      return <LoadingProgress />;
    }

    const coordinates = getMachineCoordinates(machine.Location);

    return (
      <div className="machines-admin-view">
        {/* header optimized for new admin styling guide */}
        <div className="mach-admin-header">
          <div className="header-content">
            <div className="header-text">
              {category !== "BAQUEIRA" ? (
                <h1>
                  <i className="fas fa-desktop mr-2"></i>Kiosco
                  <span className="ml-2 text-vw-dark">{machine.Serial}</span>
                </h1>
              ) : (
                <h1>
                  <i className="fas fa-desktop mr-2"></i>Zona
                  <span className="ml-2 mr-2 text-vw-dark">
                    {this.getZoneName(machine.Contract.Zone)} -{" "}
                  </span>{" "}
                  Controlador{" "}
                  <span className="text-vw-dark ml-2">{machine.Serial}</span>
                </h1>
              )}
            </div>

            <div className="header-actions">
              {role === "ADMIN" &&
                (type === "MASTER" || type === "PRODUCCION") && (
                  <Link
                    to={`/machines/${machine._id}/edit`}
                    className="mach-admin-btn bg-danger text-white"
                  >
                    <i className="fas fa-edit"></i>
                    <span className="d-none d-sm-inline">Editar</span>
                  </Link>
                )}
              {role === "ADMIN" && (
                <button
                  className={`mach-admin-btn secondary ${this.state.matrixAutoUpdate ? "rotating" : ""}`}
                  onClick={() => {
                    this.setState({
                      matrixAutoUpdate: !this.state.matrixAutoUpdate,
                    });
                    this.updateMatrixs();
                  }}
                >
                  <i className={`fas fa-sync`}></i>
                  <span className="d-none d-sm-inline">
                    {this.state.matrixAutoUpdate ? "Detener" : "Refrescar"}
                  </span>
                </button>
              )}
              <button
                className="mach-admin-btn primary"
                onClick={() => {
                  this.setState({ userpinShown: !this.state.userpinShown });
                }}
              >
                <i className="fas fa-lock"></i>
                <span className="d-none d-sm-inline">
                  {this.state.userpinShown ? "Ocultar Pines" : "Mostrar Pines"}
                </span>
              </button>

              {role === "ADMIN" && (
                <button
                  className="mach-admin-btn success"
                  onClick={() => {
                    this.setState({
                      batteriesShown: !this.state.batteriesShown,
                    });
                  }}
                >
                  <i className="fas fa-battery-full"></i>
                  <span className="d-none d-sm-inline">
                    {this.state.batteriesShown
                      ? "Ocultar Baterias"
                      : "Mostrar Baterias"}
                  </span>
                </button>
              )}
              {role === "ADMIN" && type === "MASTER" && (
                <Link
                  to={`/matrixs/${machine._id}/edit`}
                  className="mach-admin-btn primary"
                >
                  <i className="fas fa-edit"></i>
                  <span className="d-none d-sm-inline">Matriz</span>
                </Link>
              )}
            </div>
          </div>
        </div>
        {category !== "BAQUEIRA" && (
          <div className="kpi-page machine-details">
            <div className="kpi-row mb-4">
              {/* grouped status+connection */}
              <div className="kpi-card info-conn">
                <div className="kpi-card-inner">
                  <div className="d-flex align-items-center gap-2">
                    <div className="kpi-card-icon">
                      <i className="fas fa-info-circle" />
                    </div>
                    <div className="kpi-card-title">Estado</div>
                  </div>
                  <div className="kpi-value">
                    <div>
                      <MachineStatusBadge machine={machine} />
                    </div>
                    <div>{new Date(machine.Last_signal).toLocaleString()}</div>
                  </div>
                </div>
              </div>

              {/* grouped sleep times */}
              <div className="kpi-card sleep-times">
                <div className="kpi-card-inner">
                  <div className="d-flex align-items-center gap-2">
                    <div className="kpi-card-icon">
                      <i className="fas fa-moon" />
                    </div>
                    <div className="kpi-card-title">Sleep</div>
                  </div>
                  <div className="kpi-value">
                    <div>
                      Inicio:{" "}
                      {`${machine.SleepStart.substring(0, 2)}:${machine.SleepStart.substring(2)} h`}
                    </div>
                    <div>
                      Fin:{" "}
                      {`${machine.SleepEnd.substring(0, 2)}:${machine.SleepEnd.substring(2)} h`}
                    </div>
                  </div>
                  {(() => {
                    const startH = parseInt(machine.SleepStart.substring(0, 2), 10) + parseInt(machine.SleepStart.substring(2), 10) / 60;
                    const endH   = parseInt(machine.SleepEnd.substring(0, 2),   10) + parseInt(machine.SleepEnd.substring(2),   10) / 60;
                    const wraps  = endH <= startH;
                    // build segments: [{from, to, sleep}]
                    const segments = wraps
                      ? [{ from: 0, to: endH, sleep: true }, { from: endH, to: startH, sleep: false }, { from: startH, to: 24, sleep: true }]
                      : [{ from: 0, to: startH, sleep: false }, { from: startH, to: endH, sleep: true }, { from: endH, to: 24, sleep: false }];
                    return (
                      <div style={{ marginTop: 10 }}>
                        <div style={{ display: 'flex', height: 8, borderRadius: 4, overflow: 'hidden', background: '#e8f0fb' }}>
                          {segments.filter(s => s.to > s.from).map((s, i) => (
                            <div key={i} style={{ width: `${((s.to - s.from) / 24) * 100}%`, background: s.sleep ? '#2c5794' : '#dce8fb' }} />
                          ))}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 3, fontSize: 10, color: '#7d8fa8' }}>
                          <span>00:00</span><span>06:00</span><span>12:00</span><span>18:00</span><span>24:00</span>
                        </div>
                      </div>
                    );
                  })()}
                </div>
              </div>

              {/* grouped credentials */}
              <div className="kpi-card credentials">
                <div className="kpi-card-inner">
                  <div className="d-flex align-items-center gap-2">
                    <div className="kpi-card-icon">
                      <i className="fas fa-key" />
                    </div>
                    <div className="kpi-card-title">Credenciales</div>
                  </div>
                  <div className="kpi-value">
                    {category !== "BAQUEIRA" && (
                      <div>Pin Máquina: {machine.PasswordMachine}</div>
                    )}
                    {category !== "BAQUEIRA" && (
                      <div>Pin Cash: {machine.PasswordFund}</div>
                    )}
                    <div>Pin Universal: {machine.PasswordCash}</div>
                  </div>
                </div>
              </div>

              {/* separate card for token and MAC */}
              {role === "ADMIN" && (
                <div className="kpi-card token-mac">
                  <div className="kpi-card-inner">
                    <div className="d-flex align-items-center gap-2">
                      <div className="kpi-card-icon">
                        <i className="fas fa-hashtag" />
                      </div>
                      <div className="kpi-card-title">Token / MAC</div>
                    </div>
                    <div className="kpi-value">
                      <div>Token: {machine.Token}</div>
                      <div>MAC: {machine.Anydesk}</div>
                    </div>
                  </div>
                </div>
              )}
              {/* assignment card - moved from lower section */}
              {role === "ADMIN" && (
              <div className="kpi-card assignment">
                <div className="kpi-card-inner">
                  <div className="d-flex align-items-center gap-2">
                    <div className="kpi-card-icon">
                      <i className="fas fa-user"></i>
                    </div>
                    <div className="kpi-card-title">Asignación</div>
                  </div>
                  <div className="kpi-value">
                    {machine.Customer ? (
                      <div>
                        <div>
                          Cliente: {machine.Customer.Fullname || "None"}
                        </div>
                        <div>Contrato: {machine.Contract?.number || "-"}</div>
                      </div>
                    ) : (
                      <div>Sin asignar</div>
                    )}
                  </div>
                </div>
              </div>
              )}
              {/* single card for edit info stays alone */}
              {role === "ADMIN" && (
                <div className="kpi-card editor">
                  <div className="kpi-card-inner">
                    <div className="d-flex align-items-center gap-2">
                      <div className="kpi-card-icon">
                        <i className="fas fa-user-edit" />
                      </div>
                      <div className="kpi-card-title">Edición</div>
                    </div>
                    <div className="kpi-value">
                      <div>{machine.Executor}</div>
                      <div style={{ fontSize: "0.85em", opacity: 0.8 }}>
                        Último Nightscan:{" "}
                        {(() => {
                          const ts = machine.NightScanTimeStampEnd;
                          if (!ts || typeof ts !== "string" || ts.length < 14) return "—";
                          const y = ts.substring(0, 4);
                          const mo = ts.substring(4, 6);
                          const d = ts.substring(6, 8);
                          const h = ts.substring(8, 10);
                          const mi = ts.substring(10, 12);
                          // Stored in Spain wall-clock; render literally.
                          return `${d}/${mo}/${y} ${h}:${mi}`;
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {category === "BAQUEIRA" && machine.Contract.Zone !== 6 && (
          <div className="row">
            <div className="col-xs-12 col-md-8">
              <Box title="Disponibilidad por fecha" icon="th">
                <div className="row">
                  <div className="col-lg-3"></div>
                  <form onSubmit={this.handleFetchRentals} className="col-lg-6">
                    <div className="row text-center">
                      <div className="col col-lg-6 form-group">
                        <label>Inicio reserva</label>
                        <input
                          type="date"
                          value={startDate}
                          onChange={(e) =>
                            this.setState({ startDate: e.target.value })
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="col col-lg-6 form-group">
                        <label>Fin reserva</label>
                        <input
                          type="date"
                          value={endDate}
                          onChange={(e) =>
                            this.setState({ endDate: e.target.value })
                          }
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="form-row justify-content-center mt-2">
                      <button
                        className="btn bg-vw-dark text-white"
                        type="submit"
                      >
                        <i className="fas fa-sync mr-1"></i>Mostrar
                        disponibilidad
                      </button>
                      <button
                        type="button"
                        className="btn bg-vw-light text-white ml-2"
                        onClick={this.setSeasonDatesAndSubmit}
                      >
                        <i className="fas fa-calendar-alt mr-1"></i> Temporada
                        completa
                      </button>
                    </div>
                  </form>
                  <div className="col-lg-3"></div>
                </div>
              </Box>
            </div>
            <div className="col-xs-12 col-md-4">
              <Box title="Leyenda tipos de taquillas" icon="th">
                <div className="row mt-5 mb-5 text-center">
                  <div className="col">
                    <span>2 PAX</span>
                    <div className="pax2"></div>
                  </div>
                  <div className="col">
                    <span>3 PAX</span>
                    <div className="pax3"></div>
                  </div>
                  <div className="col">
                    <span>4 PAX</span>
                    <div className="pax4"></div>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        )}
        {role === "ADMIN" ? (
          <div style={{ background: '#fff', border: '1px solid #e4eaf2', borderRadius: 12, boxShadow: '0 1px 5px rgba(10,64,128,0.07)', overflow: 'hidden', marginTop: 20, marginBottom: 20 }}>
            <div className="od-page-nav" style={{ borderRadius: 0, marginTop: 0, boxShadow: 'none', borderBottom: '1px solid #e4eaf2' }}>
              {[
                { id: "1", icon: "fa-user",         label: "Cliente"    },
                { id: "2", icon: "fa-bluetooth-b",  label: "Bluetooth"  },
                { id: "3", icon: "fa-battery-half", label: "Battery"    },
                { id: "4", icon: "fa-signal",       label: "Signal"     },
                { id: "5", icon: "fa-microchip",    label: "Firmware"   },
                { id: "6", icon: "fa-code-branch",  label: "Bootloader" },
                { id: "7", icon: "fa-door-open",    label: "Aperturas"  },
              ].map(t => (
                <button
                  key={t.id}
                  className={`od-page-tab${this.state.activeTab === t.id ? " active" : ""}`}
                  onClick={() => this.toggle(t.id)}
                >
                  <i className={`fas ${t.icon}`}></i>
                  <span>{t.label}</span>
                </button>
              ))}
            </div>
            <div id="matrixScroll" style={{ padding: '16px' }}>
              {this.state.activeTab === "1" && this.createMatrix(blockedLockers)}
              {this.state.activeTab === "2" && this.createMatrixAdmin()}
              {this.state.activeTab === "3" && this.createMatrixBattery()}
              {this.state.activeTab === "4" && this.createMatrixSignal()}
              {this.state.activeTab === "5" && this.createMatrixVersion()}
              {this.state.activeTab === "6" && this.createMatrixBootloader()}
              {this.state.activeTab === "7" && this.createMatrixOpens()}
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col-xs-12 col-md-12">
              <Box title="Matriz" icon="th">
                <div id="matrixScroll">{this.createMatrix(blockedLockers)}</div>
              </Box>
            </div>
          </div>
        )}
        {/* {role === 'ADMIN' &&
          <div className="row">
            <div className="col-xs-12 col-md-12">
              <Box title="Linea de Vida" icon="cubes">
                {this.generateLiveLine()}
              </Box>
            </div>
          </div>
        } */}
        <div style={{ background: '#fff', border: '1px solid #e4eaf2', borderRadius: 12, boxShadow: '0 1px 5px rgba(10,64,128,0.07)', overflow: 'hidden', marginTop: 20, marginBottom: 20 }}>
            <div style={{ padding: '14px 20px', borderBottom: '1px solid #e4eaf2', display: 'flex', alignItems: 'center', gap: 10 }}>
              <i className="fas fa-heartbeat" style={{ color: '#e74c3c', fontSize: 15 }}></i>
              <span style={{ fontWeight: 700, fontSize: 14, color: '#1a2e4a', letterSpacing: 0.3, textTransform: 'uppercase' }}>Disponibilidad (7 días)</span>
            </div>
            <div style={{ padding: 16 }}>
              {this.generateUptimeChart()}
            </div>
          </div>
        {/* Asignación moved into top KPI row as a small card */}
        {category !== "BAQUEIRA" && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginTop: 20, marginBottom: 20 }}>

            {/* Idiomas */}
            <div style={{ background: '#fff', border: '1px solid #e4eaf2', borderRadius: 12, boxShadow: '0 1px 5px rgba(10,64,128,0.07)', overflow: 'hidden' }}>
              <div style={{ padding: '12px 16px', borderBottom: '1px solid #e4eaf2', display: 'flex', alignItems: 'center', gap: 8 }}>
                <i className="fas fa-language" style={{ color: '#3498db', fontSize: 14 }}></i>
                <span style={{ fontWeight: 700, fontSize: 13, color: '#1a2e4a', letterSpacing: 0.3, textTransform: 'uppercase' }}>Idiomas</span>
              </div>
              <div style={{ padding: '12px 16px' }}>
                <PropertyLabel
                  name="Idioma principal"
                  value={this.renderLanguage(machine.Language)}
                />
                <PropertyLabel
                  name="Idiomas"
                  value={this.renderLanguages(machine.SupportedLanguages)}
                />
              </div>
            </div>

            {/* QR */}
            <div style={{ background: '#fff', border: '1px solid #e4eaf2', borderRadius: 12, boxShadow: '0 1px 5px rgba(10,64,128,0.07)', overflow: 'hidden', position: 'relative' }}>
              <div style={{ padding: '12px 16px', borderBottom: '1px solid #e4eaf2', display: 'flex', alignItems: 'center', gap: 8 }}>
                <i className="fas fa-qrcode" style={{ color: '#9b59b6', fontSize: 14 }}></i>
                <span style={{ fontWeight: 700, fontSize: 13, color: '#1a2e4a', letterSpacing: 0.3, textTransform: 'uppercase' }}>QR</span>
              </div>
              <div style={{ padding: '12px 16px' }}>
                <PropertyLabel
                  name="Venta QR habilitada"
                  value={machine.QRActive ? "SI" : "NO"}
                />
                <PropertyLabel
                  name="Porcentaje de reserva"
                  value={`${machine.QRPercentage} %`}
                />
                <PropertyLabel
                  name="Modo de funcionamiento"
                  value={this.getQRMode(machine.QRMode)}
                />
              </div>
              {type === "LICENCIA_BASICA" && (
                <div style={proLockOverlayStyle}>
                  <div style={proLockBadgeStyle}>
                    <span style={{ fontSize: 18 }}>🔒</span>
                    <span style={{ fontWeight: 700, fontSize: 13, color: "#fff" }}>Función PRO</span>
                    <button onClick={() => this.props.push("/planes")} style={proLockButtonStyle}>⭐ Solicitar PRO</button>
                  </div>
                </div>
              )}
            </div>

            {/* Limpieza */}
            <div style={{ background: '#fff', border: '1px solid #e4eaf2', borderRadius: 12, boxShadow: '0 1px 5px rgba(10,64,128,0.07)', overflow: 'hidden' }}>
              <div style={{ padding: '12px 16px', borderBottom: '1px solid #e4eaf2', display: 'flex', alignItems: 'center', gap: 8 }}>
                <i className="fas fa-broom" style={{ color: '#e67e22', fontSize: 14 }}></i>
                <span style={{ fontWeight: 700, fontSize: 13, color: '#1a2e4a', letterSpacing: 0.3, textTransform: 'uppercase' }}>Limpieza</span>
              </div>
              <div style={{ padding: '12px 16px' }}>
                <PropertyLabel
                  name="Limpieza en alquiladas"
                  value={machine.CleanActive ? "SI" : "NO"}
                />
                <PropertyLabel
                  name="Limpieza en todas"
                  value={machine.CleanAll ? "SI" : "NO"}
                />
              </div>
            </div>

            {/* Bloqueo */}
            <div style={{ background: '#fff', border: '1px solid #e4eaf2', borderRadius: 12, boxShadow: '0 1px 5px rgba(10,64,128,0.07)', overflow: 'hidden', position: 'relative' }}>
              <div style={{ padding: '12px 16px', borderBottom: '1px solid #e4eaf2', display: 'flex', alignItems: 'center', gap: 8 }}>
                <i className="fas fa-calendar-check" style={{ color: '#16a085', fontSize: 14 }}></i>
                <span style={{ fontWeight: 700, fontSize: 13, color: '#1a2e4a', letterSpacing: 0.3, textTransform: 'uppercase' }}>Bloqueo</span>
              </div>
              <div style={{ padding: '12px 16px' }}>
                <PropertyLabel
                  name="Bloqueo habilitado"
                  value={machine.BookActive ? "SI" : "NO"}
                />
                <PropertyLabel
                  name="Porcentaje de bloqueo"
                  value={`${machine.BookPercentage} %`}
                />
                <PropertyLabel
                  name="Hora de liberación"
                  value={`${machine.BookFreeTime.substring(0, 2)}:${machine.BookFreeTime.substring(2)} h`}
                />
              </div>
              {type === "LICENCIA_BASICA" && (
                <div style={proLockOverlayStyle}>
                  <div style={proLockBadgeStyle}>
                    <span style={{ fontSize: 18 }}>🔒</span>
                    <span style={{ fontWeight: 700, fontSize: 13, color: "#fff" }}>Función PRO</span>
                    <button onClick={() => this.props.push("/planes")} style={proLockButtonStyle}>⭐ Solicitar PRO</button>
                  </div>
                </div>
              )}
            </div>

          </div>
        )}
        {category !== "BAQUEIRA" &&
          (machine.PaymentMethods === 0 || machine.PaymentMethods === 1) && (
            <div style={{ background: '#fff', border: '1px solid #e4eaf2', borderRadius: 12, boxShadow: '0 1px 5px rgba(10,64,128,0.07)', overflow: 'hidden', marginTop: 20 }}>
              <div style={{ padding: '14px 20px', borderBottom: '1px solid #e4eaf2', display: 'flex', alignItems: 'center', gap: 10 }}>
                <i className="fas fa-dollar-sign" style={{ color: '#27ae60', fontSize: 15 }}></i>
                <span style={{ fontWeight: 700, fontSize: 14, color: '#1a2e4a', letterSpacing: 0.3, textTransform: 'uppercase' }}>Cajas</span>
              </div>
              <div style={{ padding: 16 }}>
                <MoneyTable machine={this.props.machines.machine} />
              </div>
            </div>
          )}

        {role === "ADMIN" && (
          <div className="mach-admin-header admin-details-header mt-4">
            <div className="header-content">
              <div className="header-text">
                <h1>
                  <i className="fas fa-user-shield mr-2"></i>
                  <span className="text-vw-dark">
                    Detalles de administrador
                  </span>
                </h1>
              </div>
            </div>
          </div>
        )}
        {role === "ADMIN" && (
          <div>
            <div className="od-page-nav">
              {[
                { id: "config", icon: "fa-sliders-h",           label: "Configuración" },
                { id: "faults", icon: "fa-tools",               label: "Averías" },
                { id: "remote", icon: "fa-terminal",            label: "Acciones Remotas" },
                ...(type === "MASTER" ? [
                  { id: "critical", icon: "fa-exclamation-triangle", label: "Acciones Críticas", danger: true },
                ] : []),
              ].map(t => (
                <button
                  key={t.id}
                  className={`od-page-tab${this.state.adminActiveTab === t.id ? " active" : ""}${t.danger ? " danger" : ""}`}
                  onClick={() => this.toggleAdmin(t.id)}
                >
                  <i className={`fas ${t.icon}`}></i>
                  <span>{t.label}</span>
                </button>
              ))}
            </div>

            <TabContent activeTab={this.state.adminActiveTab}>
              <TabPane tabId="config">
                <div className="od-config-page">
                  {/* Row 1 */}
                  <div className="od-config-columns">
                    {/* Col 1: Info Admin */}
                    <div className="od-config-col">
                      <div className="od-config-section">
                        <div className="od-config-section-hd">
                          <i className="fas fa-info-circle"></i> Info Admin
                        </div>
                        <div className="od-prop-list">
                          <div className="od-prop-row"><span className="od-prop-k">Pin Master</span><span className="od-prop-v">{machine.PasswordMaster}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Pin QC</span><span className="od-prop-v">{machine.PasswordQC}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Fabricacion</span><span className="od-prop-v">{dateFormat(new Date(machine.Build_date), "dd/mm/yy")}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Tipo</span><span className="od-prop-v">{machine.Type}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">SW</span><span className="od-prop-v"><span className="od-ver-badge">{machine.Sw_version}</span></span></div>
                          <div className="od-prop-row"><span className="od-prop-k">FW</span><span className="od-prop-v"><span className="od-ver-badge">{machine.Fw_version}</span></span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Updater</span><span className="od-prop-v"><span className="od-ver-badge">{machine.Up_version}</span></span></div>
                          <div className="od-prop-row"><span className="od-prop-k">ESP32</span><span className="od-prop-v"><span className="od-ver-badge">{machine.ESP32_version}</span></span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Bloqueo Cancel U1000</span><span className="od-prop-v">{machine.BlockU1000Cancelling ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                        </div>
                      </div>
                    </div>
                    {/* Col 2: Taquillas */}
                    <div className="od-config-col">
                      <div className="od-config-section">
                        <div className="od-config-section-hd">
                          <i className="fas fa-lock"></i> Taquillas
                        </div>
                        <div className="od-prop-list">
                          <div className="od-prop-row"><span className="od-prop-k">Night Scan</span><span className="od-prop-v">{machine.ScanNightAllowed ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Day Scan</span><span className="od-prop-v">{machine.ScanDayAllowed ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Day Scan Interval</span><span className="od-prop-v">{machine.ScanDayInterval}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Num. Aperturas</span><span className="od-prop-v">{machine.PassOpens}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Alarma abierto</span><span className="od-prop-v">{machine.AlarmDefault ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Sonido teclado</span><span className="od-prop-v">{machine.BuzzerDefault === "1" ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Cierre manual</span><span className="od-prop-v">{machine.OpenModeDefault ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Password Recovery</span><span className="od-prop-v">{machine.PasswordUniversal || <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Num. caract. clave</span><span className="od-prop-v">{machine.PasswordLength}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Potencia BLE</span><span className="od-prop-v">{machine.BLEPower}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Cadencia BLE</span><span className="od-prop-v">{machine.BLEAdvTime}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Teclado</span><span className="od-prop-v">{machine.Keypad ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                        </div>
                      </div>
                    </div>
                    {/* Col 3: Detalles */}
                    <div className="od-config-col">
                      <div className="od-config-section">
                        <div className="od-config-section-hd">
                          <i className="fas fa-list-alt"></i> Detalles
                        </div>
                        <div className="od-prop-list">
                          <div className="od-prop-row"><span className="od-prop-k">Locker Antiguo</span><span className="od-prop-v">{machine.OldLocker ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Vestuarios</span><span className="od-prop-v">{machine.GenderMode ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Firmware nuevo</span><span className="od-prop-v">{machine.LockersFirmwareVersion === 1 ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Aviso de ticket</span><span className="od-prop-v">{machine.PrinterSensorActive ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Recovery Start</span><span className="od-prop-v">{machine.StartPassRecovery ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">LED Estado</span><span className="od-prop-v">{machine.LedStatusIndicator ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Metodos de pago</span><span className="od-prop-v">{this.getPayments(machine.PaymentMethods)}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Pasos sonoros</span><span className="od-prop-v">{machine.GeneralSoundActive ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Bloqueo alquiler</span><span className="od-prop-v">{machine.UndefinedLockerRental ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Codigos de canje</span><span className="od-prop-v">{machine.RedeemCode ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                        </div>
                      </div>
                    </div>
                    {/* Col 4: TPV + PAYTEF + REDSYS */}
                    <div className="od-config-col">
                      <div className="od-config-section">
                        <div className="od-config-section-hd">
                          <i className="fas fa-credit-card"></i> TPV
                        </div>
                        <div className="od-prop-list">
                          <div className="od-prop-row"><span className="od-prop-k">Num. serie</span><span className="od-prop-v">{machine.Tpv_serial}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Cargo maximo</span><span className="od-prop-v">{machine.Tpv_max} EUR</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Timeout cancel.</span><span className="od-prop-v">{machine.TpvCancelTime}s</span></div>
                        </div>
                      </div>
                      <div className="od-config-section">
                        <div className="od-config-section-hd">
                          <i className="fas fa-receipt"></i> PAYTEF
                        </div>
                        <div className="od-prop-list">
                          <div className="od-prop-row"><span className="od-prop-k">TCOD</span><span className="od-prop-v">{machine.Tpv_tcod}</span></div>
                        </div>
                      </div>
                      <div className="od-config-section">
                        <div className="od-config-section-hd">
                          <i className="fas fa-landmark"></i> REDSYS
                        </div>
                        <div className="od-prop-list">
                          <div className="od-prop-row"><span className="od-prop-k">Codigo comercio</span><span className="od-prop-v">{machine.TpvBusinessCode}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Num. Terminal</span><span className="od-prop-v">{machine.TpvTerminalCode}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Clave Firma</span><span className="od-prop-v">{machine.TpvFirmKeyCode}</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Row 2: CASH + Dispositivos + Modulos + Seguridad */}
                  <div className="od-config-columns">
                    {/* CASH */}
                    <div className="od-config-col">
                      <div className="od-config-section">
                        <div className="od-config-section-hd">
                          <i className="fas fa-euro-sign"></i> CASH
                        </div>
                        <div className="od-prop-list">
                          <div className="od-prop-row"><span className="od-prop-k">Max devo diario</span><span className="od-prop-v">{machine.LimiteDevolucionDiario} EUR</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Max devo de golpe</span><span className="od-prop-v">{machine.LimiteDevolucion} EUR</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Cobro max Cash</span><span className="od-prop-v">{machine.CashMax} EUR</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Billetes</span><span className="od-prop-v">{this.getBillerAcceptance(machine.BillerAcceptance)}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Monedas</span><span className="od-prop-v">{this.getCoinAcceptance(machine.CoinAcceptance)}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Fondo fijo</span><span className="od-prop-v">{machine.FixedChangeInitial ? <span className="od-flag-yes">SI</span> : <span className="od-flag-no">NO</span>}</span></div>
                          <div className="od-prop-row"><span className="od-prop-k">Fondo de caja</span><span className="od-prop-v">{machine.ChangeInitial} EUR</span></div>
                        </div>
                      </div>
                    </div>
                    {/* Dispositivos de pago */}
                    <div className="od-config-col">
                      <div className="od-config-section">
                        <div className="od-config-section-hd">
                          <i className="fas fa-puzzle-piece"></i> Dispositivos de pago
                        </div>
                        <div className="od-prop-list">
                          {(this.props.machines.machine.PaymentDevices || []).map((device, i) => (
                            <div key={i} className="od-prop-row">
                              <span className="od-prop-k">{device.Type}</span>
                              <span className="od-prop-v">{device.Device}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    {/* Modulos */}
                    <div className="od-config-col">
                      <div className="od-config-section">
                        <div className="od-config-section-hd" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span><i className="fas fa-cubes"></i> Modulos</span>
                          {(this.props.machines.machine.Modules || []).length > 0 && (
                            <button
                              onClick={e => {
                                e.stopPropagation()
                                e.preventDefault()
                                const mods = this.props.machines.machine.Modules || []
                                mods.forEach(m => {
                                  const url = window.location.origin + `/modules/${m.serialNumber}`
                                  const w = window.open(url, '_blank', 'noopener,noreferrer')
                                  if (w) w.blur()
                                })
                              }}
                              style={{
                                background: 'linear-gradient(135deg, #022040, #0a4080)',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 6,
                                padding: '3px 10px',
                                fontSize: 11,
                                fontWeight: 600,
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 5,
                              }}
                            >
                              <i className="fas fa-external-link-alt"></i>
                              Abrir todos ({(this.props.machines.machine.Modules || []).length})
                            </button>
                          )}
                        </div>
                        <div className="od-config-toggle-body">
                          <button
                            className="od-config-toggle-btn"
                            onClick={() => this.setState({ showModules: !this.state.showModules })}
                          >
                            <i className={`fas fa-${this.state.showModules ? 'eye-slash' : 'eye'}`}></i>
                            {this.state.showModules ? " Ocultar" : " Mostrar"}
                          </button>
                          {this.state.showModules && (
                            <AssignedModuleList Modules={this.props.machines.machine.Modules} />
                          )}
                        </div>
                      </div>
                    </div>
                    {/* Seguridad */}
                    <div className="od-config-col">
                      <div className="od-config-section">
                        <div className="od-config-section-hd">
                          <i className="fas fa-shield-alt"></i> Seguridad
                        </div>
                        <div className="od-config-toggle-body">
                          <button
                            className="od-config-toggle-btn"
                            onClick={() => this.setState({ showSecurity: !this.state.showSecurity })}
                          >
                            <i className={`fas fa-${this.state.showSecurity ? 'eye-slash' : 'eye'}`}></i>
                            {this.state.showSecurity ? " Ocultar" : " Mostrar"}
                          </button>
                          {this.state.showSecurity && (
                            <AssignedPairingSecurityList SecurityLockers={this.props.machines.machine.SecurityLockers} />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="faults">
                <br />
                <Box title="Averias" icon="info">
                  {this.identifyFaults()}
                </Box>
              </TabPane>

              <TabPane tabId="remote">
                <br />
                {type === "MASTER" ? (
                  <div>
                    <div className="kpi-page">
                      <div className="kpi-row">
                        <div className="kpi-card full-width">
                          <div className="kpi-card-inner">
                            <RemoteActionAddForm machine={machine} />
                          </div>
                        </div>
                      </div>
                      <div className="kpi-row">
                        <RemoteActionsList remoteActions={remoteActions} />
                      </div>
                    </div>
                  </div>
                ) : (
                  <Box title="Acciones Remotas" icon="hand-paper">
                    <p>No tiene permisos para ver acciones remotas.</p>
                  </Box>
                )}
              </TabPane>
              <TabPane tabId="critical">
                <br />
                <div>
                  <div className="kpi-page">
                    <div className="kpi-row">
                      <div className="kpi-card full-width">
                        <div className="kpi-card-inner">
                          <CriticalActionAddForm machine={machine} />
                        </div>
                      </div>
                    </div>
                    <div className="kpi-row">
                      <RemoteActionsList remoteActions={remoteActions} />
                    </div>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>
        )}
        {/* {
          (role === 'ADMIN' && type === 'MASTER') &&
          <div className="row mb-2 mt-5">
            <div className="col-xs-12 col-sm-6 col-md-6">
              <h1>
                <span className="text-vw-light">HACIENDA </span>
                <span className="text-vw-dark">ITALIANA</span>
              </h1>
            </div>
          </div>
        } */}
        {/* {
          (role === 'ADMIN' && type === 'MASTER') &&
          <Box title="Agenzia della entrate" icon="hand-paper">
            {
              (machine.Agenczia_della_entrate && machine.Agenczia_della_entrate.length)
            }

            {
              (machine.Agenczia_della_entrate && machine.Agenczia_della_entrate.date) &&
              <div>
                <hr />
                <h6 className="text-vw-dark">AGENZIA DELLA ENTRATE</h6>
                <PropertyLabel name="Fecha"
                  value={
                    machine.Agenczia_della_entrate ? dateFormat(machine.Agenczia_della_entrate.date, 'dd/mm/yy HH:MM') : ''
                  } />
                <div>
                  <div className="d-flex justify-content-between">
                    <h6>Descargar:</h6>
                    <span className="text-muted cursor-pointer" onClick={this.downloadAgenczia}>
                      <i className={`fas fa-download float-right mr-1`}></i>
                    </span>
                  </div>
                </div>
              </div>
            }
          </Box>
        } */}

        {/* Confirm deletion */}
        <div>
          <Modal
            isOpen={this.state.deleteConfirmShown}
            toggle={this.deleteConfirmToggle}
          >
            <ModalHeader toggle={this.deleteConfirmToggle}>
              Confirmar
            </ModalHeader>
            <ModalBody>
              {machine.Customer ? (
                <p>
                  Una máquina no se puede borrar mientras tenga un contrato
                  asignado.
                </p>
              ) : (
                <p>¿Estás seguro de borrar la máquina?</p>
              )}
            </ModalBody>
            <ModalFooter>
              {!machine.Customer && (
                <Button color="primary mr-1" onClick={this.delete}>
                  Borrar
                </Button>
              )}
              <Button color="secondary" onClick={this.deleteConfirmToggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </div>

        {/* View all user pins */}
        <div>
          <Modal isOpen={this.state.userpinShown} toggle={this.userpinToggle}>
            <ModalHeader toggle={this.userpinToggle}>
              Listado de Pines de Usuario
            </ModalHeader>
            <ModalBody>{this.renderUserpin()}</ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.userpinToggle}>
                Cerrar
              </Button>
            </ModalFooter>
          </Modal>
        </div>

        {/* View all batteries */}
        <div>
          <Modal
            isOpen={this.state.batteriesShown}
            toggle={this.batteriesToggle}
          >
            <ModalHeader toggle={this.batteriesToggle}>
              Listado de Baterias
            </ModalHeader>
            <ModalBody>{this.renderBatteries()}</ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.batteriesToggle}>
                Cerrar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    );
  }
}

const proLockOverlayStyle = {
  position: "absolute",
  top: 45,
  right: 0,
  bottom: 0,
  left: 0,
  background: "rgba(0, 29, 58, 0.72)",
  backdropFilter: "blur(3px)",
  borderRadius: "0 0 12px 12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 10,
};

const proLockBadgeStyle = {
  textAlign: "center",
  padding: "12px 28px",
  background: "linear-gradient(135deg, #001d3a 0%, #003366 100%)",
  borderRadius: 10,
  border: "2px solid #f59e0b",
  boxShadow: "0 4px 20px rgba(245,158,11,0.35)",
  display: "flex",
  alignItems: "center",
  gap: 12,
  flexDirection: "row",
  whiteSpace: "nowrap",
};

const proLockButtonStyle = {
  padding: "8px 20px",
  borderRadius: 20,
  border: "none",
  background: "#f59e0b",
  color: "#001d3a",
  fontWeight: 700,
  fontSize: 13,
  cursor: "pointer",
};

const mapStateToProps = (state) => ({
  machines: state.machines,
  audits: state.audits.audits,
  matrixs: state.matrixs.matrixs,
  articles: state.articles.articles,
  error: state.machines.error,
  loading: state.machines.loading,
  remoteActions: state.remoteactions,
  role: state.auth.role,
  type: state.auth.type,
  category: state.auth.category,
  rentals: state.rentals.rentals,
  keepAliveSignals: state.keepAliveSignals,
});

const mapDispatchToProps = (dispatch) => ({
  deleteMachine: bindActionCreators(deleteMachine, dispatch),
  fetchMachine: bindActionCreators(fetchMachine, dispatch),
  fetchMatrixs: bindActionCreators(fetchMatrixs, dispatch),
  fetchRemoteActions: bindActionCreators(fetchRemoteActions, dispatch),
  fetchAudits: bindActionCreators(fetchAudits, dispatch),
  fetchArticles: bindActionCreators(fetchArticles, dispatch),
  fetchRentals: bindActionCreators(fetchRentals, dispatch),
  fetchKeepAliveSignals: bindActionCreators(fetchKeepAliveSignals, dispatch),
  push: bindActionCreators(push, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MachineDetailsView);
